import BlockContent from '@sanity/block-content-to-react'
import { serializers } from './serializers'

export const CustomBlockContent = ({body}) => {
  return <BlockContent blocks={body} serializers={serializers}/>
}